import React from 'react';
import { iconSize } from '../../../constants/icon.constants';
import Icon from '../icon';

const IconOrImage = ({ assets }) => {
  const { Size200, full, alt } = assets?.[0] || {};
  if (!Size200 && !full) return null;
  return Size200 ? (
    <img loading="lazy" className="product-model-navigation__cta-image" src={Size200} alt={alt} />
  ) : (
    <Icon iconField={{ iconUrl: full, iconAlt: alt }} color="primary" size={iconSize['xlg']} />
  );
};

export default IconOrImage;
